import { CONTENT_TYPE_HEADER } from '../../constants/http';
import { DO_NOT_INCLUDE_AUTH_HEADER } from './constants';

export const createFileUploadAxiosConfig = (file) => ({
	headers: {
		[CONTENT_TYPE_HEADER]: file.type,
		[DO_NOT_INCLUDE_AUTH_HEADER]: 'true'
	},
});
